var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlBack24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.1781818,10.5490909 L5.93454545,10.5490909 L13.0909091,3.44727271 C13.6602645,2.88092978 13.6627065,1.96026445 13.0963636,1.39090909 C12.5300207,0.821553731 11.6093554,0.819111633 11.04,1.38545451 L1.3963636,10.9636364 C0.83040552,11.5301386 0.83040552,12.4480432 1.3963636,13.0145455 L10.9854545,22.6036364 C11.3518142,22.9797396 11.8909931,23.1318228 12.3998879,23.0025976 C12.9087826,22.8733726 13.31008,22.4824715 13.4526152,21.9771431 C13.5951503,21.4718148 13.4572688,20.9288305 13.0909091,20.5527273 L5.98909091,13.4509091 L22.1781818,13.4509091 C22.9794968,13.4509091 23.6290909,12.8013149 23.6290909,12 C23.6290909,11.1986851 22.9794968,10.5490909 22.1781818,10.5490909 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconActionBack24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconActionBack32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color",
    mask: "url(#mask-2)",
    fill: "#282828",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.454545, -5.454545)",
    id: "Rectangle-Copy-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34.9090909,
    height: 34.9090909
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlBack24);
export default __webpack_public_path__ + "static/media/controlBack24.683761aaae56855f20fc8db5c3ea69fc.svg";
export { ForwardRef as ReactComponent };